import { createSlice } from "@reduxjs/toolkit"
const initialState={
    
    currentSensors:[],
    
}

const sensorsSlice=createSlice({
name:'sensors',

initialState,
reducers:{
    
    loginSuccessAllSens:(state,{payload})=>{
        state.currentSensors=payload;
        

    },
    deleteAllSensors:(state)=>{
        state.currentSensors=[]
    }
   
    
    

}
})
export const {loginSuccessAllSens,deleteAllSensors}=sensorsSlice.actions

export default sensorsSlice.reducer